module.exports = __webpack_public_path__ + "static/img/D02-萧山区江南初级中学1.2722ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/D02-萧山区江南初级中学1.png
// module id = vCaK
// module chunks = 0